import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deactivateContractPriceList } from '../../../common/api/clients/contracts.api';
import { queries } from '../../../common/api/queryKeys/queries';

export const useContractPriceListDeactivate = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deactivateContractPriceList,
        onSuccess: (_, { contractId }) =>
            queryClient.invalidateQueries({ queryKey: queries.contracts.detail(contractId).queryKey }),
    });
};
